"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountingInput = void 0;
var React = require("react");
var TextInput_1 = require("../TextInput");
function shouldHandleChangeEvent(event, maxLength) {
    return event.target.value.length <= maxLength;
}
var CountingInput = function (props) {
    // @FIXME: prettier won't let me use the ?? operator on props.value
    //   so we'll just have to hack around it for now. maybe if we bump
    //   the version it would work.
    //   -jbjork, 2023-03-08
    var value = typeof props.value === 'undefined' ? '' : props.value;
    var remainingCharacters = props.maxLength - String(value).length;
    return (React.createElement("div", { className: "sok-counting-input" },
        React.createElement(TextInput_1.TextInput, __assign({}, props, { onChange: function (event) {
                if (!shouldHandleChangeEvent(event, props.maxLength)) {
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
                if (props.onChange) {
                    // prettier also won't let me use the ?.() operator to call this method.
                    props.onChange(event);
                }
            } })),
        React.createElement("div", { className: "sok-counting-input-counter" }, remainingCharacters)));
};
exports.CountingInput = CountingInput;
//# sourceMappingURL=index.js.map